import { render, staticRenderFns } from "./LocationMappingsForm.vue?vue&type=template&id=00dcabec"
import script from "./LocationMappingsForm.vue?vue&type=script&lang=js"
export * from "./LocationMappingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports